import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import '@infl-ts/ui-advocate-theme';
import { useBlockData } from '@infl-ts/util-block-data-provider';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, Card, useTheme } from '@mui/material';
import { createContext, useCallback, useEffect, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { useCheckWidth } from './container-media-query'; // Todo: remove the last cards bottom margin, or make this configurable otherwise

import { jsx as _jsx } from "react/jsx-runtime";
export var BlockWidthContext = /*#__PURE__*/createContext(0);
export var BlockWidthWrapper = function BlockWidthWrapper(_ref) {
  var children = _ref.children,
      _ref$card = _ref.card,
      card = _ref$card === void 0 ? false : _ref$card,
      mediaQuery = _ref.mediaQuery,
      sx = _ref.sx;

  var _useBlockData = useBlockData(),
      id = _useBlockData.id,
      typename = _useBlockData.typename;

  var _useState = useState(0),
      containerWidth = _useState[0],
      setContainerWidth = _useState[1];

  var matchesMediaQuery = useCheckWidth(_objectSpread(_objectSpread({}, mediaQuery), {}, {
    width: containerWidth
  }));

  var _useTheme = useTheme(),
      maxBlockWidth = _useTheme.site.maxBlockWidth;

  var onResize = useCallback(function (width) {
    return setContainerWidth(width || 0);
  }, []);

  var _useResizeDetector = useResizeDetector({
    onResize: onResize,
    refreshMode: 'debounce',
    refreshRate: 100,
    refreshOptions: {
      leading: true
    }
  }),
      containerRef = _useResizeDetector.ref;

  useEffect(function () {
    if (containerRef.current) onResize(containerRef.current.offsetWidth);
  }, []);
  var Comp = card ? Card : Box;
  return /*#__PURE__*/_jsx(BlockWidthContext.Provider, {
    value: containerWidth,
    "data-element": "unknown",
    "data-component": "BlockWidthWrapper",
    "data-source-file": "block-width-context.tsx",
    children: /*#__PURE__*/_jsx(Comp, {
      "data-block-id": id,
      "data-block-typename": typename,
      sx: mergeSxProps({
        maxWidth: maxBlockWidth,
        mx: 'auto',
        mb: 0,
        width: 1
      }, sx),
      className: "block-container",
      "data-element": "Comp",
      "data-component": "BlockWidthWrapper",
      "data-source-file": "block-width-context.tsx",
      children: /*#__PURE__*/_jsx(Box, {
        ref: containerRef,
        "data-element": "Box",
        "data-component": "BlockWidthWrapper",
        "data-source-file": "block-width-context.tsx",
        children: typeof children === 'function' ? children({
          containerWidth: containerWidth,
          matchesMediaQuery: matchesMediaQuery
        }) : children
      })
    })
  });
};